import {createAsyncThunk} from "@reduxjs/toolkit";
import {AccountInfoState} from "@/app/(pages)/account/accountSlice";
import $http from "@/app/_api";

type userVipInfo = {
    vipExp: number,
    vipLevel: number
}

export const updateAccountAsync = createAsyncThunk(
    'counter/fetchCount',
    async (userInfo: userVipInfo) => {
        try {
        const {vipExp} = userInfo
        const mergeData:AccountInfoState['info'] = {
            userVipExp: 0,
            userNextVipExp: 0,
            userVipName: '',
            vipConfigList: {
                vipLevels: [],
                vipBenefits: []
            }
        }

        const response = await $http.Account.vipConfigList();
        const { vipLevels } = response;

        // 根据用户当前vip等级获取用户vip等级名称
        const userVipLevel = vipLevels.find((item: any) => item.vipLevel === userInfo.vipLevel);
        mergeData.userVipName = userVipLevel?.levelName || "";

        // 根据用户当前vip等级获取用户下一个vip等级所需经验
        const userNextVipLevel = vipLevels.find((item: any) => item.vipLevel === userInfo.vipLevel + 1);
        mergeData.userNextVipExp = userNextVipLevel?.reqExperience || 0;

        // 用户当前vip经验
        mergeData.userVipExp = vipExp;

        // 客户端vip等级配置列表
        mergeData.vipConfigList = response;
        console.log(mergeData)

        return mergeData;

        } catch (e) {
            console.log(e)
        }

        // const response = await fetchCount(amount)
        // // The value we return becomes the `fulfilled` action payload
        // return response.data
    }
)

// export async function getAccountInfoData(userInfo: UserInfoState) {
//     const {vipExp} = userInfo
//
//     const mergeData:AccountInfoState['info'] = {
//         userVipExp: 0,
//         userNextVipExp: 0,
//         userVipName: '',
//         vipConfigList: {
//             vipLevels: [],
//             vipBenefits: []
//         }
//     }
//
//     const response = await $http.Account.vipConfigList();
//     const { vipLevels } = response;
//
//     // 根据用户当前vip等级获取用户vip等级名称
//     const userVipLevel = vipLevels.find((item: any) => item.vipLevel === userInfo.vipLevel);
//     mergeData.userVipName = userVipLevel?.levelName || "";
//
//     // 根据用户当前vip等级获取用户下一个vip等级所需经验
//     const userNextVipLevel = vipLevels.find((item: any) => item.vipLevel === userInfo.vipLevel + 1);
//     mergeData.userNextVipExp = userNextVipLevel?.reqExperience || 0;
//
//     // 用户当前vip经验
//     mergeData.userVipExp = vipExp;
//
//     // 客户端vip等级配置列表
//     mergeData.vipConfigList = response;
//
//     return mergeData;
// }